import { useChangePassword } from './use-change-password'
import useConfirmEmail from './use-confirm-email'
import { useRestorePasswordByEmail } from './use-restore-password-by-email'

const queries = {
  useConfirmEmail,
  useChangePassword,
  useRestorePasswordByEmail,
}

export default queries
